import React from 'react';
import PropTypes from 'prop-types';

const InstrumentTableItem = props => {
  const { value, label, classModifiers, baseClasses } = props;

  return (
    <div className={baseClasses('row', classModifiers)}>
      <span className={baseClasses('title')}>{label}</span>
      <span className={baseClasses('value', classModifiers)}>{value}</span>
    </div>
  );
};

InstrumentTableItem.propTypes = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  baseClasses: PropTypes.func.isRequired,
  classModifiers: PropTypes.arrayOf(PropTypes.string)
};

InstrumentTableItem.defaultProps = {
  classModifiers: []
};

export default InstrumentTableItem;
